<template>
  <li class="incredi-hierarcy">
    <div>
      <div
        class="circle gordita-400-11"
        :style="{ background: color }"
      />
      <div
        class="incredi-hierarcy--row incredi-hierarcy--title"
        :style="{ gridTemplateColumns: `${width} auto` }"
      >
        <p class="gordita-400-11">{{ title.text }}</p>
        <p class="sans-400-12">{{ title.value }}</p>
      </div>
    </div>

    <ul style="display: flex; flex-direction: column">
      <li
        v-for="(item, index) in value"
        :key="index"
        style="display: inline-flex"
        :style="{ borderLeft: `1px solid ${color}`, borderBottom: `1px solid ${color}` }"
      >
        <slot
          name="item"
          :item="item"
        >
          <div
            class="incredi-hierarcy--row"
            :style="{ gridTemplateColumns: `${width} auto` }"
          >
            <p class="gordita-400-11">{{ item.text }}</p>
            <p class="sans-400-12">{{ item.value }}</p>
          </div>
        </slot>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'black',
    },
    width: {
      type: String,
      default: '64px',
    },
    value: {
      type: Array,
      validator: val => val.every(item => item && item.text !== undefined && item.value !== undefined),
      default: () => [],
    },
    title: {
      type: Object,
      validator: val => val.text !== undefined && val.value !== undefined,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 1em;
  li {
    &:first-child {
      position: relative;
      top: 1px;
    }
    &:last-child {
      ul {
        border-radius: 1px;
        border-left: 1px solid white;
        margin-left: -17px;
      }
    }
  }
}
li {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 11px;
  border-radius: 1px;
  border-width: 0 0 1px 1px;
  white-space: nowrap;
  :deep(.sbic--incredi-hierarcy--row) {
    top: 12px;
  }
  :deep(div) {
    flex-grow: 1;
    padding-left: 8.5px;
    margin: 0;
    background: $-system-app-white;
    position: relative;
    p {
      /* font-size: 11px; */

      margin: 0;
    }
  }

  ul {
    border-radius: 1px;
    padding-left: 6px;
    position: relative;
  }
}
.incredi-hierarcy--row {
  display: grid;
}
li.incredi-hierarcy {
  margin-bottom: 4px;
  left: -14px;
  top: -7px;
  position: relative;
  display: inline-flex;
  flex-direction: column;
  border-bottom: 0px;
  border-left: none;

  p {
    padding: 2px 0;
    /* font-size: 11px; */
  }
  > div {
    display: inline-flex;
    position: relative;
    left: -6px;
    margin-bottom: -13px;
    align-items: center;
    .circle {
      flex-grow: 0;
      border-radius: 50%;
      height: 8px;
      width: 8px;
    }
    > p {
      position: relative;
      top: 6px;
      margin: 0 0 0 8px;
    }
  }
}
</style>
